export type TRateLikelihoodTone = 'positive' | 'caution' | 'negative';

export interface IRateLikelihood {
  label: string;
  tone: TRateLikelihoodTone;
}

/**
 * Maps a posted rate to its qualitative "likelihood to fill" relative to the
 * office's recommended (regional average) rate. Thresholds mirror the legacy
 * rate-status copy: >=106% and >=100% are positive, >=85% is a caution, and
 * anything lower is negative. A missing/zero average never penalizes.
 */
export const getRateLikelihood = (rate: number, averageRate: number): IRateLikelihood => {
  const percentage = averageRate > 0 ? (rate / averageRate) * 100 : 100;

  if (percentage >= 106) {
    return { label: 'More likely to fill', tone: 'positive' };
  }
  if (percentage >= 100) {
    return { label: 'Likely to fill', tone: 'positive' };
  }
  if (percentage >= 85) {
    return { label: 'Less likely to fill', tone: 'caution' };
  }
  return { label: 'Unlikely to fill', tone: 'negative' };
};
